import axios from 'axios';
import BackIcon from 'imagesUwKluis/svg/back.svg';
import { useState, useContext } from 'react';
import {Link} from 'react-router-dom';
import useForm from '../../../hooks/useForm';
import Button from '../../shared/Button';
import Input from '../../shared/Input';
import Box from '../../shared/layouts/Box';
import WithIcon from '../../shared/layouts/WithIcon';
import Labeled from '../../shared/WithLabel';
import Container from './LoginContainer';
import WhiteLabelContext from '../../../context/WhiteLabelContext';
import {useTranslation} from "react-i18next";
import {sendDataToReactNative} from "../../../utils/communicateWithRN";

const ForgotPassword = () => {
  const [state, handleState] = useForm({email: ''});
  const [message, setMessage] = useState(null);
  const [errors, setErrors] = useState({});
  const {platformName} = useContext(WhiteLabelContext);

  const { t } = useTranslation();

  const handleSubmit = e => {
    e.preventDefault();
    axios
      .post('/password/email', state)
      .then(res => {
        sendDataToReactNative(JSON.stringify(res?.data))
        setMessage(res?.data?.message)
      })
      .catch(err => {
        sendDataToReactNative(JSON.stringify(err.response.data.errors))
        setErrors(err.response.data.errors)
      });
  };

  return (
    <Container handleSubmit={handleSubmit}>
      <Link
        id="goBack"
        to="/login"
        css={(theme) => ({
          fontSize: theme.fontSizes.m,
          marginTop: '8px',
          textDecoration: 'underline',
          color: theme.colors.secondaryButtonHover,
          fontWeight: 'bold',
        })}
      >
        <WithIcon space="none" color="secondaryButtonHover">
          <BackIcon width="1.5rem" height="1.5rem" />
          {t('Terug')}
        </WithIcon>
      </Link>
      <Box fontScale="2xl" fontWeight="bold">
        {t('Wachtwoord vergeten?')}
      </Box>
      {message ? (
        <Box>{message}</Box>
      ) : (
        <>
          <Box>
            {t(
              'Kan gebeuren! We sturen je meteen een link voor een nieuw wachtwoord. Welk e-mailadres is gekoppeld aan {{platformName}}?',
              { platformName }
            )}
          </Box>
          <Labeled label={t('Jouw e-mailadres')}>
            <Input
              name="email"
              value={state.email}
              onChange={handleState}
              errors={errors?.email}
              placeholder={t('Vul je e-mailadres in')}
            />
          </Labeled>
          <Button type="submit" variant="primary" width="100%">
            {t('Verstuur reset e-mail')}
          </Button>
        </>
      )}
    </Container>
  );
};
export default ForgotPassword;
